import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBarContainer from '@containers/common/NavBarContainer';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { StyledMediaLayoutContainer } from './constants/media.styled';

const MediaLayout = () => {
    const fromAccountActivity = window?.location?.search.includes('contactId');

    return (
        <StyledMediaLayoutContainer>
            <ConditionalRendering isTrue={!fromAccountActivity}>
                <div className="padding-b-20" data-testid="media-layout">
                    <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
                </div>
            </ConditionalRendering>
            <Outlet />
        </StyledMediaLayoutContainer>
    );
};

export default MediaLayout;
